package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.FixedProductsHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.SelectionHeadersEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.FixProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.ProductSets
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.SearchBarWithAddEditCloseIcon
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.components.GeneralSelectionInformation
import org.jetbrains.compose.web.css.LineStyle

@Composable
fun Selection(
    windowSizeMode: WindowSizeModeEnum,
    articles: List<ProductItem>,
    templateCategoryList: List<TemplateCategoryModel>?,
    priceLevels: List<String?>?,
    selectedProduct: GetProduct?,
    selectedFixedProductSet: FixProduct?,
    productSets: ProductSets?,
    selectedProductSet: SetModel?,
    updateProductSets: (String, dynamic) -> Unit,
    onProductSetItemClick: (String) -> Unit,
    onSearchInProductSets: (String) -> Unit,
    onAddProductSetIconClick: () -> Unit,
    onDeleteProductSetIconClick: () -> Unit,
    onAddProductFixIconClick: () -> Unit,
    onSearchInFixedProduct: (String) -> Unit,
    onFixedProductClick: (String) -> Unit,
    onDeleteFixedProductIconClick: () -> Unit,
    onEditProductFixIconClick: () -> Unit,
    updateSelectedProductSet:(SetModel?)->Unit,
)
{
    Column(
        modifier = VerticalScrollBehavior
            .toModifier()
            .showContentInOnePage()
            .fillMaxWidth()
            .padding(
                bottom = Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    )
    {
        CheckboxComponent(
            title = Strings.current().isTheMenuName,
            checkStatus = selectedProduct?.isMenuName?:false,
            onChecked = {
                updateProductSets(
                    ApiUtils.Field.isMenuName,
                    true
                )
            },
            onUnChecked = {
                updateProductSets(
                    ApiUtils.Field.isMenuName,
                    false
                )
            },
        )

        MediumContentTitle(
            title = Strings.current().selection,
        )

        SearchBarWithAddEditCloseIcon(
            searchFieldWidth = Dimen.semiLargeEditTextWidth,
            showEdit = false,
            onSearchInfo ={
                onSearchInProductSets(it)
            },
            onAddClick = {
                onAddProductSetIconClick()
            },
            onDeleteClick = {
                if (selectedProductSet!=null)
                    onDeleteProductSetIconClick()
            }

        )

        CustomTable(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding),
            height = Dimen.priceTableHeight,
            minHeight = Dimen.priceTableHeight,
            onRowClick = {it,row->
                @Suppress("UNCHECKED_CAST")
                val categoryData = row["category"] as? Map<String, Any?>
                val categoryId = categoryData?.get("id")?.toString()
                if (categoryId != null) {
                    onProductSetItemClick(categoryId)
                }

            },
            selectedId =selectedProductSet?.category?.id,
            data = productSets?.sets?.map { set ->
                mapOf(
                    "category" to mapOf(
                        "id" to set.category?.id,
                        "name" to set.category?.name
                    ),
                    SelectionHeadersEnum.NUMBER.key to "",
                    SelectionHeadersEnum.TEMPLATE.key to set.category?.name,
                    SelectionHeadersEnum.MIN_QUANTITY.key to set.minQuantity,
                    SelectionHeadersEnum.MAX_QUANTITY.key to set.maxQuantity,
                    SelectionHeadersEnum.FIXED_QUANTITY.key to
                            set.fixProducts?.joinToString("\n") {
                                it?.code ?: "-" },
                    SelectionHeadersEnum.QUANTITY.key to
                            set.fixProducts?.joinToString("\n") {
                                it?.amount?.toString() ?: "-" },
                    SelectionHeadersEnum.PRICE.key to
                            set.fixProducts?.joinToString("\n") {
                                it?.price?.toString() ?: "-"
                            }
                )
            },
            footerType = FooterType.NONE,
            columns = SelectionHeadersEnum.entries.map { header ->
                TableColumn(
                    header = header.title,
                    key = header.key,
                    isSortable = true,
                    isNumeric = header.isNumeric,
                    overflow = header.overflow
                )
            },
        )

        if (selectedProductSet!=null){
            GeneralSelectionInformation(
                selectedProductSet=selectedProductSet,
                priceLevels=priceLevels,
                windowSizeMode=windowSizeMode,
                templateCategories = templateCategoryList,
                updateSelectedProductSet = {
                    updateSelectedProductSet(it)
                }
            )

            MediumContentTitle(
                title = Strings.current().fixedProducts,
            )

            SearchBarWithAddEditCloseIcon(
                searchFieldWidth = Dimen.semiLargeEditTextWidth,
                onEditClick = {
                    onEditProductFixIconClick()
                },
                onSearchInfo ={
                    onSearchInFixedProduct(it)
                },
                onAddClick = {
                    onAddProductFixIconClick()
                },
                onDeleteClick = {
                    onDeleteFixedProductIconClick()
                }

            )

            CustomTable(
                modifier = Modifier
                    .margin(bottom = Dimen.extraLargePadding),
                height = Dimen.priceTableHeight,
                minHeight = Dimen.priceTableHeight,
                onRowClick = { id, row ->
                    onFixedProductClick(id)
                },
                selectedId = selectedFixedProductSet?.code,
                data = selectedProductSet.fixProducts?.map { fixProduct ->
                    mapOf(
                        "category" to mapOf(
                            "id" to fixProduct?.code
                        ),
                        FixedProductsHeadersEnum.NUMBER.key to fixProduct?.code,
                        FixedProductsHeadersEnum.ARTICLE.key to
                            articles.find { it.id==fixProduct?.code }?.name,
                        FixedProductsHeadersEnum.QUANTITY.key to fixProduct?.amount,
                        FixedProductsHeadersEnum.PRICE.key to fixProduct?.price,
                    )
                },
                footerType = FooterType.NONE,
                columns = FixedProductsHeadersEnum.entries.map { header ->
                    TableColumn(
                        header = header.title,
                        isSortable = true,
                        isNumeric = header.isNumeric,
                        key = header.key
                    )
                },
            )
        }



    }


}